import React, { useState, useEffect } from 'react'
import './Header.css'
import Logof from '../../assets/logof.png'
import Bars from '../../assets/bars.png'
import { Link } from 'react-scroll'

const Header = () => {
  const [menuOpened, setMenuOpened] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
      if (window.innerWidth > 768) setMenuOpened(false)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const closeMenu = () => setMenuOpened(false)

  return (
    <div className="header">
      <div className="logo-f-container header-logo-align">
        <div className="logo-f">
          <img src={Logof} alt="Company Logo" />
        </div>
      </div>

      {isMobile && (
        <div
          className="mobile-menu-button"
          onClick={() => setMenuOpened(!menuOpened)}
        >
          <img src={Bars} alt="Menu" />
        </div>
      )}

      {(menuOpened || !isMobile) && (
        <ul className='header-menu'>
          <li><Link onClick={closeMenu} to='home' spy={true} smooth={true}>Home</Link></li>
          <li><Link onClick={closeMenu} to='programs' spy={true} smooth={true}>Programs</Link></li>
          <li><Link onClick={closeMenu} to='reasons' spy={true} smooth={true}>Why Us</Link></li>
          <li><Link onClick={closeMenu} to='plans' spy={true} smooth={true}>Plans</Link></li>
          <li><Link onClick={closeMenu} to='testimonials' spy={true} smooth={true}>Testimonials</Link></li>
        </ul>
      )}
    </div>
  )
}

export default Header
